import { TFunction } from 'i18next'

import { RecurringInvoiceStatus } from '@features/recurringInvoices/enums/recurringInvoiceStatus'

const statusTKeys = {
  [RecurringInvoiceStatus.All]: 'recurring_invoices.status.all.label',
  [RecurringInvoiceStatus.Completed]: 'recurring_invoices.status.completed.label',
  [RecurringInvoiceStatus.Draft]: 'recurring_invoices.status.draft.label',
  [RecurringInvoiceStatus.Ongoing]: 'recurring_invoices.status.ongoing.label',
  [RecurringInvoiceStatus.Paused]: 'recurring_invoices.status.paused.label',
}

export const getRecurringInvoiceStatusLabel = (status: RecurringInvoiceStatus | undefined, t: TFunction) => {
  return status ? t(statusTKeys[status]) : ''
}
